import script from "./AboutPageDirectoryPublicCompact.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutPageDirectoryPublicCompact.vue?vue&type=script&setup=true&lang=js"

import "./AboutPageDirectoryPublicCompact.vue?vue&type=style&index=0&id=4e6ea65b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e6ea65b"]])

export default __exports__